/* eslint-disable @typescript-eslint/ban-types */
import { IconButton, InputAdornment } from '@material-ui/core'
import React from 'react'
import {
  renderHelpersText,
  renderErrorInField,
  renderUpdatedInField,
} from '@flatsy/utils/Functions/form/Helpers'
import FormTextField from '../../../../../Global/TextField'
import { FieldsType, SingleFieldProps } from '../../../../Types'
import { isAnObject, renderIcon, renderValue, renderType, isVisible } from './Utils'

const PasswordField = <T extends {}>({
  field,
  input,
  meta,
  values,
  justSubmitted,
}: SingleFieldProps<T>): React.ReactElement => {
  /**
   * @description render label or condition label
   * @param field
   * @param values
   */
  const renderLabelInField = (field: FieldsType, values: T) => {
    return field.conditional ? field.conditional(values).label : field.label
  }

  /**
   * @description event when click on the button icon
   */
  const showPassword = () => {
    input.onChange({
      visible: isAnObject(input) ? !isVisible(input) : false,
      value: renderValue(input),
    })
  }

  /**
   * @description event when input change
   * @param val
   */
  const onChange = (val: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    input.onChange({
      visible: isAnObject(input) ? isVisible(input) : false,
      value: val.target.value,
    })
  }

  return (
    <FormTextField
      error={renderErrorInField(meta)}
      updated={renderUpdatedInField(meta, justSubmitted)}
      helperText={renderHelpersText(field, meta.touched, meta.error, meta.submitError)}
      label={renderLabelInField(field, values)}
      {...input}
      type={renderType(input)}
      autoComplete="current-password"
      value={renderValue(input)}
      testid="form-field-password"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton aria-label="toggle password visibility" onClick={showPassword} edge="end">
              {renderIcon(input)}
            </IconButton>
          </InputAdornment>
        ),
      }}
      onChange={onChange}
      fullWidth
    />
  )
}

export default PasswordField
